/** MG mark — transparent PNG, black-bg source trimmed */
const LOGO_ASPECT = 821 / 447;
const LOGO_SRC = '/images/logo.png?v=2';

export default function Logo({ size = 40, showText = true }) {
  const height = size;
  const width = Math.round(size * LOGO_ASPECT);

  return (
    <span className="logo">
      <img
        className="logo__mark"
        src={LOGO_SRC}
        alt="Mahageeta Technology"
        width={width}
        height={height}
        style={{ height: size, width: 'auto' }}
        decoding="async"
      />
      {showText && (
        <span className="logo__text">
          <span className="logo__name">Mahageeta</span>
          <span className="logo__sub">Technology</span>
        </span>
      )}
    </span>
  );
}
